<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="meunTitle2" :title3="meunTitle3"></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <div class="mainTitle">
            <div>
              <span class="userName">捐助详情-小程序</span>
              <div class="rightBtn">
                <el-button v-if="bill_mail.id" plain size="small" @click="modifyExpress(bill_mail, bill_mail_title)">{{ bill_mail_title }}</el-button>
                <el-button v-if="certificate_mail.id" plain size="small" @click="modifyExpress(certificate_mail, certificate_mail_title)">{{ certificate_mail_title }}</el-button>
              </div>
            </div>
            <div class="infos">
              <div class="info2">
                <div class="divStyle">
                  <p>捐助金额</p>
                  <h1>{{ info.total }}</h1>
                </div>
                <div class="divStyle">
                  <p>纸质证书状态</p>
                  <h1>{{ info.certificate_status }}</h1>
                </div>
                <div class="divStyle">
                  <p>票据状态</p>
                  <h1>{{ info.bill_status }}</h1>
                </div>
                <div class="divStyle">
                  <p>关联校友</p>
                  <h1 class="name" @click="toUser()">{{ info.name_cn }}</h1>
                </div>
              </div>
            </div>
          </div>
          <el-tabs v-model="activeName" class="elTabs">
            <el-tab-pane label="" name="first">
              <div class="mainbody">
                <div class="baseInfo">
                  <h4>捐助订单</h4>
                  <div class="info">
                    <p>
                      <span>商户订单号:</span>
                      {{ info.out_trade_no }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>支付单号:</span>
                      {{ info.transaction_id }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>APPID:</span>
                      {{ info.appid }}
                    </p>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info">
                    <p>
                      <span>微信支付商户号:</span>
                      {{ info.mchid }}
                    </p>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info">
                    <p>
                      <span>交易时间:</span>
                      {{ info.create_time }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>更新时间:</span>
                      {{ info.update_time }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>支付时间:</span>
                      {{ info.success_time }}
                    </p>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info">
                    <p>
                      <span>付款银行:</span>
                      {{ info.bank_type }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>交易状态:</span>
                      {{ info.trade_state_desc }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>订单金额:</span>
                      {{ info.total }}
                    </p>
                  </div>
                </div>

                <div class="divide_line_style"></div>

                <div class="baseInfo">
                  <h4>用户信息</h4>
                  <div class="info">
                    <p>
                      <span>用户姓名:</span>
                      {{ info.name }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>联系电话:</span>
                      {{ info.mobile }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>与学校关系:</span>
                      {{ info.relation }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>入校时间:</span>
                      {{ info.year }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>留言:</span>
                      {{ info.remark }}
                    </p>
                  </div>
                </div>

                <div class="divide_line_style"></div>

                <div class="baseInfo">
                  <h4>申请票据</h4>
                  <div class="info">
                    <p>
                      <span>收货姓名:</span>
                      {{ bill_mail.user_name }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>收货电话:</span>
                      {{ bill_mail.tel_number }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>收货地址:</span>
                      {{ bill_mail.address }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span class="copy" v-clipboard:copy="copyLinkTextBill" v-clipboard:success="onLinkCopy" v-clipboard:error="onLinkCopyError">一键复制</span>
                    </p>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info">
                    <p>
                      <span>发货人员:</span>
                      {{ bill_mail.consignor }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>发货快递:</span>
                      {{ bill_mail.operators }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>发货单号:</span>
                      {{ bill_mail.express_number }}
                    </p>
                  </div>
                </div>

                <div class="divide_line_style"></div>

                <div class="baseInfo">
                  <h4>申请纸质证书</h4>
                  <div class="info">
                    <p>
                      <span>收货姓名:</span>
                      {{ certificate_mail.user_name }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>收货电话:</span>
                      {{ certificate_mail.tel_number }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>收货地址:</span>
                      {{ certificate_mail.address }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span class="copy" v-clipboard:copy="copyLinkTextCertificate" v-clipboard:success="onLinkCopy" v-clipboard:error="onLinkCopyError">一键复制</span>
                    </p>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info">
                    <p>
                      <span>发货人员:</span>
                      {{ certificate_mail.consignor }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>发货快递:</span>
                      {{ certificate_mail.operators }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>发货单号:</span>
                      {{ certificate_mail.express_number }}
                    </p>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-main>
        <journal-express-dialog ref="_journalExpressDialog" @toSave="getInfo"></journal-express-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayout'
import journalExpressDialog from '@/components/dialog/journalExpressDialog'
import { response } from '@/utils/resUtils.js'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    journalExpressDialog
  },
  data() {
    return {
      tableLoading: false,
      URL_PATH: URL_PATH,
      userid: '',
      meunItem: null,
      meunTitle: '校友基本信息列表',
      meunTitle2: '捐助详情',
      meunTitle3: '捐助详情',
      activeName: 'first',
      info: {}, //个人信息
      bill_mail: {},
      certificate_mail: {},
      bill_mail_title: '票据发货',
      certificate_mail_title: '证书发货',
      copyLinkTextBill: '',
      copyLinkTextCertificate: ''
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.userid = this.meunItem.userid
      if (this.$route.query.list) {
        // 捐助列表进入
        this.meunTitle3 = null
      } else {
        // 用户详情进入
        this.meunTitle2 = '校友详情'
      }
      this.getInfo()
    },
    onLinkCopy: function (e) {
      this.$message('链接已复制')
    },
    onLinkCopyError: function (e) {
      console.log('Failed to copy texts')
    },
    initCopyText() {
      this.copyLinkTextBill = this.bill_mail.user_name + ',' + this.bill_mail.tel_number + ',' + this.bill_mail.address
      this.copyLinkTextCertificate = this.certificate_mail.user_name + ',' + this.certificate_mail.tel_number + ',' + this.certificate_mail.address
    },
    // 一键复制
    copy(info) {
      if (info.id) {
        let str = info.user_name + ',' + info.tel_number + ',' + info.address
        var input = document.createElement('input') // 直接构建input
        input.value = str // 设置内容
        document.body.appendChild(input) // 添加临时实例
        input.select() // 选择实例内容
        document.execCommand('Copy') // 执行复制
        document.body.removeChild(input) // 删除临时实例
        this.$message('信息已复制')
      } else {
        this.$message.error('无可复制信息')
      }
    },
    // 修改快递
    modifyExpress(info, title) {
      Api.verifyApi(CApi.api_updateDonationMail, verify => {
        if (verify) {
          this.$nextTick(() => {
            this.$refs._journalExpressDialog.show(info.id, info.operators, info.express_number, title)
          })
        }
      })
    },
    // 获取信息
    getInfo: function () {
      this.tableLoading = true
      this.$api
        .getAppletsDonationInfo({
          token: localStorage.getItem('token'),
          id: this.$route.query.id
        })
        .then(({ data }) => {
          this.info = data.Data
          if (data.Data.bill_mail) {
            this.bill_mail = data.Data.bill_mail
          }
          if (data.Data.certificate_mail) {
            this.certificate_mail = data.Data.certificate_mail
          }

          this.info.total = this.info.total / 100.0

          this.info.year = Utils.dateFormat3(this.info.year * 1000)
          this.info.create_time = Utils.dateFormat(this.info.create_time * 1000)
          this.info.update_time = Utils.dateFormat(this.info.update_time * 1000)
          this.info.success_time = Utils.dateFormat(this.info.success_time * 1000)
          this.info.bill_status = StrUtils.getBillStatus(this.info.bill_status)
          this.info.certificate_status = StrUtils.getCertificateStatus(this.info.certificate_status)

          if (this.bill_mail && this.bill_mail.operators) {
            this.bill_mail_title = '票据发货修改'
          }
          if (this.certificate_mail && this.certificate_mail.operators) {
            this.certificate_mail_title = '证书发货修改'
          }

          this.initCopyText()
          this.tableLoading = false
        })
        .catch(({ error }) => {
          this.tableLoading = false
        })
    },
    // 跳转用户详情
    toUser() {
      Api.verifyApi(CApi.api_getAisInfoById, verify => {
        if (verify) {
          this.meunItem.userid = this.info.ais_info_id
          localStorage.setItem('meunItem', JSON.stringify(this.meunItem))
          this.$router.push('/data/user-details')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -10px;
  margin-left: -20px;
  margin-right: -20px;
}
.mainTitle .userName {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .rightBtn {
  float: right;
}
.mainTitle .infos {
  width: 100%;
  float: left;
}
.mainTitle .infos span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .infos p {
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainTitle .infos h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .info1 {
  width: 35%;
  float: left;
}
.mainTitle .info2 {
  width: 40%;
  float: right;
}
.mainTitle .info2 .divStyle {
  width: 25%;
  float: right;
}
.mainTitle .info2 .divStyle p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);
  // float: right;
}
.mainTitle .info2 .divStyle h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .info2 .divStyle .name {
  cursor: pointer;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #4d8bf8;
}
.elTabs {
  margin-top: -40px;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 36px 32px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .baseInfo {
  width: 100%;
  float: left;
  margin-top: 32px;
}
.mainbody .info {
  width: 360px;
  float: left;
}
.mainbody .photo {
  float: left;
  width: 222px;
  height: 220px;
  margin-top: 18px;
  background-color: #c4c4c4;
  border-radius: 0px;
}
.mainbody .info h4 {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info .h4place {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}

.mainbody .info span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info .copy {
  cursor: pointer;
  margin-left: 100px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #1890ff;
}
.mainbody .info p {
  margin-top: 16px;
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainbody .info .pplace {
  margin-top: 16px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}
.mainbody .tableInfo {
  margin-top: 24px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.divide_line_style {
  width: 100%;
  height: 0.5px;
  background: #f0f0f0;
  float: left;
  margin-top: 48px;
}
</style>


// WEBPACK FOOTER //
// src/pages/dataMgr/journalDetails.vue